import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../../Services/notification.service';
import { Router, RouterLink } from '@angular/router';
import { inject } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Import FormsModule
import autoTable from 'jspdf-autotable'; // For PDF export
import * as XLSX from 'xlsx'; // For Excel export
import jsPDF from 'jspdf'; // For PDF export
import FileSaver from 'file-saver'; // For file saving
import { StockService } from '../../../../Services/Stock/stock.service';
import { environment } from '../../../../../environments/environment';
import { RetailStockComponent } from '../../report/retail-stock/retail-stock.component';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-ready-product-list',
  standalone: true,
  imports: [NgFor, RouterLink, FormsModule, NgIf, RetailStockComponent],
  templateUrl: './ready-product-list.component.html',
  styleUrl: './ready-product-list.component.css',
})
export class ReadyProductListComponent implements OnInit {
  paginatedStockList: any[] = [];
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 0;
  stockList: any[] = [];
  searchValues: { [key: string]: string } = {};
  sortKey: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  showDropdown: boolean = false;
  globalSearchText: string = '';
  isRetailModalOpen = false;
  selectedStockItem: any = null;
  startDate: string = '';
  endDate: string = '';
  filteredStockList: any[] = [];


  // Define the default set of fields for stock products based on your rules
  defaultFields = [
    { key: 'st_image1', label: 'Product Image', isImage: true, selected: true },
    { key: 'st_item_category', label: 'Item Category', selected: true, subKey: 'name' },
    { key: 'st_item_code', label: 'Item Code', selected: true },
    { key: 'st_item_name', label: 'Item Name', selected: true, subkey: 'name' },
    { key: 'st_distribution', label: 'Stock Type', selected: true },
    { key: 'st_quantity', label: 'Quantity', selected: true },
    { key: 'st_total_wt', label: 'Total Weight', selected: true },
    { key: 'st_silver_purity', label: 'Silver Purity', selected: true },
    { key: 'st_net_weight', label: 'Total Fine Weight', selected: true },
    // { key: 'st_supplier_name', label: 'Supplier Name', selected: true, subkey: 'name' },
    // { key: 'st_metal_rate', label: 'Silver Rate', selected: true },
    { key: 'st_cny_labour', label: 'CNY Labour', selected: true },
    { key: 'st_per_gm_labour', label: 'Total Labour', selected: true },
    { key: 'st_per_gm_shipping', label: 'Per GM Shipping', selected: true },
    { key: 'st_other_expense_per_gm', label: 'Other Expense Per GM', selected: true },
    { key: 'st_packaging_cost', label: 'Packaging Cost', selected: true },
    { key: 'st_per_gm_cost_without_packaging', label: 'Per GM Cost W/O Packaging ', selected: true },
    { key: 'st_stone_type', label: 'Stone Type', selected: true },
    // { key: 'st_color', label: 'Stone Colour', selected: true },
    // { key: 'st_polish_type', label: 'Polish Type', selected: true },
    // { key: 'st_item_size', label: 'Size', selected: true },
  ];

  selectedFields: any[] = [];
  titleTag: boolean = true;

  constructor(
    private stockService: StockService, // Use the new service
    private notificationService: NotificationService
  ) { }

  router = inject(Router);

  ngOnInit(): void {
    this.loadSelectedFields();
    this.getStockList();
    this.hideTitle();
  }

  openRetailModal(item: any) {
    this.selectedStockItem = item;
    this.isRetailModalOpen = true;
  }

  closeRetailModal() {
    this.isRetailModalOpen = false;
    this.selectedStockItem = null;
  }

  hideTitle() {
    const currentUrl = this.router.url;
    if (currentUrl.includes('report')) {
      this.titleTag = false;
    }
  }

  loadSelectedFields() {
    const stockSelection = localStorage.getItem('Stocksselectedfeilds');
    if (stockSelection) {
      // Parse the stored JSON
      const storedFields = JSON.parse(stockSelection);

      const storedFieldMap = new Map(
        storedFields.map((field: any) => [field.key, field.selected])
      );

      this.selectedFields = this.defaultFields.map((defaultField) => ({
        ...defaultField,
        selected: storedFieldMap.has(defaultField.key)
          ? storedFieldMap.get(defaultField.key)
          : defaultField.selected,
      }));
    } else {
      this.selectedFields = [...this.defaultFields];
    }
  }

  saveSelectedFields() {
    localStorage.setItem(
      'stockSelectedfielditem',
      JSON.stringify(this.selectedFields)
    );
  }

  getStockList() {
    let params = new HttpParams().set('stock_type', 'Ready-Product').set('product_type', 'piece-wise');
    this.stockService.getStockEntriesWithParams(params).subscribe(
      (response: any) => {
        console.log('Stock List Response:', response);
        if (response?.data?.length) {
          this.stockList = response.data.reverse();
          this.filterTable(); // Apply filters and pagination after fetching data
        } else {
          this.stockList = [];
          this.paginatedStockList = [];
          this.totalPages = 0;
        }
      },
      (error: any) => {
        this.notificationService.showError(
          'Failed to fetch stock entries.',
          'Error'
        );
        this.stockList = [];
        this.paginatedStockList = [];
        this.totalPages = 0;
      }
    );
  }
  deleteReadyProduct(id: number): void {

    const confirmDelete = window.confirm(
      'Are you sure you want to delete this ready product?'
    );

    if (confirmDelete) {

      this.stockService.deleteStockEntry(id).subscribe(

        (response: any) => {

          this.notificationService.showSuccess(
            'Ready product deleted successfully!',
            'Success'
          );

          this.getStockList();
        },

        (error: any) => {

          this.notificationService.showError(
            error?.error?.message ||
            'Failed to delete ready product.',
            'Error'
          );
        }
      );
    }
  }
  editStock(id: any) {
    // Implement navigation or modal for editing if needed
  }

  filterTable() {

    if (!this.stockList) return;

    let filtered = this.stockList.filter((item: any) => {

      /* ================= DATE FILTER ================= */

      if (this.startDate || this.endDate) {

        const createdAt = item['created_at'];
        if (!createdAt) return false;

        const itemDate = new Date(createdAt).setHours(0, 0, 0, 0);

        const start = this.startDate
          ? new Date(this.startDate).setHours(0, 0, 0, 0)
          : null;

        const end = this.endDate
          ? new Date(this.endDate).setHours(0, 0, 0, 0)
          : null;

        if (start && itemDate < start) return false;
        if (end && itemDate > end) return false;
      }

      /* ================= COLUMN FILTER ================= */

      const matchesFieldFilters = this.selectedFields.every((field) => {

        if (!field.selected) return true;

        const searchTerm = (this.searchValues[field.key] || '')
          .trim()
          .toLowerCase();

        if (!searchTerm) return true;

        const fieldValue = (item[field.key] ?? '')
          .toString()
          .toLowerCase();

        return fieldValue.includes(searchTerm);
      });

      /* ================= GLOBAL SEARCH ================= */

      const matchesGlobalSearch = this.globalSearchText
        ? Object.values(item).some((val) =>
          (val ?? '')
            .toString()
            .toLowerCase()
            .includes(this.globalSearchText.trim().toLowerCase())
        )
        : true;

      return matchesFieldFilters && matchesGlobalSearch;
    });

    /* ================= SORT ================= */

    if (this.sortKey) {
      filtered.sort((a: any, b: any) => {

        const valA = a[this.sortKey] ?? '';
        const valB = b[this.sortKey] ?? '';

        return this.sortDirection === 'asc'
          ? valA > valB ? 1 : valA < valB ? -1 : 0
          : valA < valB ? 1 : valA > valB ? -1 : 0;
      });
    }

    /* ================= SAVE FILTERED ================= */

    this.filteredStockList = filtered;

    /* ================= PAGINATION ================= */

    this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);
    this.currentPage = Math.min(this.currentPage, this.totalPages || 1);

    const start = (this.currentPage - 1) * this.itemsPerPage;

    this.paginatedStockList = filtered.slice(
      start,
      start + this.itemsPerPage
    );
  }


  sortBy(key: string) {
    if (this.sortKey === key) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortKey = key;
      this.sortDirection = 'asc';
    }
    this.filterTable();
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.filterTable();
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.filterTable();
    }
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.filterTable();
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.filterTable();
    }
  }

  get pageNumbers(): number[] {
    const pageNumbers: number[] = [];
    const maxPagesToShow = 5;

    if (this.totalPages <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);

      if (this.currentPage > 2) {
        pageNumbers.push(-1);
      }
      let start = Math.max(
        2,
        this.currentPage - Math.floor(maxPagesToShow / 2) + 1
      );
      let end = Math.min(
        this.totalPages - 1,
        this.currentPage + Math.floor(maxPagesToShow / 2) - 1
      );
      if (this.currentPage <= Math.floor(maxPagesToShow / 2) + 1) {
        end = Math.min(this.totalPages - 1, maxPagesToShow - 1);
      }
      if (
        this.currentPage >=
        this.totalPages - Math.floor(maxPagesToShow / 2)
      ) {
        start = Math.max(2, this.totalPages - maxPagesToShow + 2);
      }

      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }
      if (this.currentPage < this.totalPages - 1) {
        if (
          pageNumbers[pageNumbers.length - 1] !== this.totalPages &&
          pageNumbers[pageNumbers.length - 1] !== -1
        ) {
          pageNumbers.push(-1);
        }
      }
      if (!pageNumbers.includes(this.totalPages) && this.totalPages > 1) {
        pageNumbers.push(this.totalPages);
      }
    }

    const uniquePageNumbers = Array.from(new Set(pageNumbers)).sort(
      (a, b) => a - b
    );
    return uniquePageNumbers;
  }

  get allFieldsSelected(): boolean {
    return this.selectedFields.every((field) => field.selected);
  }

  get noFieldsSelected(): boolean {
    return this.selectedFields.every((field) => !field.selected);
  }

  selectAllFields() {
    this.selectedFields.forEach((field) => (field.selected = true));
    this.saveSelectedFields();
    this.filterTable();
  }

  deselectAllFields() {
    this.selectedFields.forEach((field) => (field.selected = false));
    this.saveSelectedFields();
    this.filterTable();
  }

  get selectedFieldss() {
    return this.selectedFields.filter((field) => field.selected);
  }

  applyColumnSelection() {
    this.saveSelectedFields();
    this.showDropdown = false;
    this.filterTable();
  }

  /* ============================================================
     IMAGE PROXY HELPERS
  ============================================================ */

  proxyImageUrl(url: string): string {

    if (!url) return '';

    // Already proxied
    if (url.includes('/api/image-proxy/')) return url;

    const backendBase = environment.apiBaseUrl.replace(/\/api\/$/, '');

    // Fix wrong stocks folder
    url = url.replace('/storage/stocks/', '/storage/products/');

    const match = url.match(/\/storage\/(.+)$/);

    if (!match) return url;

    return `${backendBase}/api/image-proxy/${match[1]}`;
  }


  /* ============================================================
     LOAD IMAGE AS BASE64
  ============================================================ */

  async loadImageBase64(url: string): Promise<string | null> {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.statusText);

      const blob = await res.blob();

      return await new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.readAsDataURL(blob);
      });

    } catch (err) {
      console.error('Image load FAILED:', url, err);
      return null;
    }
  }


  /* ============================================================
     PRELOAD ALL PDF IMAGES
  ============================================================ */

  /* ============================================================
     PRELOAD ALL PDF IMAGES
  ============================================================ */

  async preparePdfImages(): Promise<void> {

    console.log(' Preparing images for PDF...');

    // Use full list to match general-list behavior
    const dataToProcess = this.paginatedStockList;

    for (const row of dataToProcess as any[]) {
      if (!row.st_image1) continue;
      console.log('➡ Row:', row.id, row.st_image1);
      const imageUrl = this.proxyImageUrl(row.st_image1);
      row.__img = await this.loadImageBase64(imageUrl);

      console.log(
        row.__img ? 'Image OK' : ' Image NULL'
      );
    }
    console.log(' Image preload finished');
  }

  downloadPDF(): void {
    // We'll wrap the logic in an async IIFE or change method signature if possible.
    // Since this is triggered by a button click, we can make it async.
    this.downloadPDFAsync();
  }

  async downloadPDFAsync(): Promise<void> {
    await this.preparePdfImages();
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a3',
    });

    const selectedFields = this.selectedFields.filter(f => f.selected);

    if (!selectedFields.length) {
      this.notificationService.showError(
        'Please select at least one column',
        'Error'
      );
      return;
    }

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    /* ---------- HEADER ---------- */

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(15);
    doc.text('Stock List Report', pageWidth / 2, 16, { align: 'center' });

    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text(
      `Generated on: ${new Date().toLocaleString()}`,
      pageWidth - 15,
      10,
      { align: 'right' }
    );

    /* ---------- TABLE ---------- */

    const headers = [
      { header: 'No.', dataKey: 'no' },
      ...selectedFields.map(f => ({
        header: f.label,
        dataKey: f.key,
      })),
    ];

    // Use full stockList for PDF body
    const sourceData = this.getExportSourceData();

    const body = sourceData.map((item, index) => {

      const row: any = { no: index + 1 };

      selectedFields.forEach(f => {
        const value = item[f.key];

        if (value && typeof value === 'object' && f.subKey) {
          row[f.key] = value[f.subKey] ?? '';
        } else if (f.key === 'st_image1') {
          row[f.key] = '';          //  NEVER render base64 text
          row.__img = item.__img;  //  store image here
        } else {
          row[f.key] = this.getDisplayValue(value);
        }
      });

      return row;
    });

    autoTable(doc, {
      columns: headers,
      body,

      startY: 24,

      margin: { left: 6, right: 6 },

      theme: 'grid',

      // 🔥 critical — stop sideways pagination
      horizontalPageBreak: false,

      rowPageBreak: 'auto',

      // 🔥 force table to page width
      tableWidth: 'auto', // changed from pageWidth - 12 to match general-list better? Or keep explicit width.
      // general-list uses 'auto' for tableWidth.


      styles: {
        fontSize: 6.2,
        cellPadding: 1.3,
        overflow: 'linebreak',
        valign: 'middle',
      },

      headStyles: {
        fillColor: [193, 151, 37],
        textColor: 255,
        halign: 'center',
        fontSize: 7,
        fontStyle: 'bold',
      },

      columnStyles: {
        no: { cellWidth: 12, halign: 'center' },
      },

      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },

      /* ---------- IMAGE DRAWING ---------- */
      didParseCell: (data: any) => {
        // Only body rows
        if (data.section !== 'body') return;

        // Only image column
        if (data.column.dataKey === 'st_image1') {
          data.cell.styles.minCellHeight = 32;
          data.cell.styles.halign = 'center';
          data.cell.styles.valign = 'middle';
        }
      },

      didDrawCell: (data: any) => {
        if (data.column.dataKey !== 'st_image1') return;
        const rowData: any = data.row.raw;
        const img = rowData?.__img;

        if (!img) return;

        try {
          const imgW = 28;
          const imgH = 28;
          const x = data.cell.x + (data.cell.width - imgW) / 2;
          const y = data.cell.y + (data.cell.height - imgH) / 2;

          doc.addImage(
            img,
            'JPEG',
            x,
            y,
            imgW,
            imgH,
            undefined,
            'FAST'
          );
        } catch (err) {
          console.error(' addImage failed:', err);
        }
      },

      didDrawPage: () => {
        doc.setFontSize(8);
        doc.text(
          `Page ${(doc as any).getNumberOfPages()}`,
          pageWidth / 2,
          pageHeight - 10,
          { align: 'center' }
        );
      },
    });

    doc.save('stock-list-report.pdf');
  }



  downloadExcel(): void {
    const selectedFields = this.selectedFields.filter(
      (field) => field.selected
    );

    // ✅ numeric backend keys
    const numericKeys = [
      'st_quantity',
      'st_purity',
      'st_total_wt'
    ];

    const sourceData = this.getExportSourceData();

    const data = sourceData.map((item, index) => {

      const row: any = { 'No.': index + 1 };

      selectedFields.forEach((field) => {
        let value: any;

        // ✅ handle nested object fields
        if (field.subKey) {
          value = item[field.key]?.[field.subKey] ?? '';
        }

        // normal field
        else {
          value = item[field.key];
        }

        // ✅ force numeric columns
        if (numericKeys.includes(field.key)) {
          value =
            value !== null &&
              value !== undefined &&
              value !== ''
              ? parseFloat(value)
              : 0;
        }

        row[field.label] = value;
      });

      return row;
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // ✅ force numeric cell type
    Object.keys(worksheet).forEach((cell) => {
      if (cell.startsWith('!')) return;

      const c = worksheet[cell];
      if (typeof c.v === 'number') {
        c.t = 'n';
      }
    });

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Stock List': worksheet },
      SheetNames: ['Stock List'],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    FileSaver.saveAs(
      new Blob([excelBuffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
      'ready-product-list.xlsx'
    );
  }


  downloadJSONAll(): void {
    const data = this.getExportSourceData();

    const jsonString = JSON.stringify(data, null, 2);

    const blob = new Blob([jsonString], { type: 'application/json' });
    const fileName = 'ready-product-list.json';

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(link.href);
  }

  downloadCSV(): void {
    const data = this.getExportSourceData();

    if (!data.length) return;

    const selectedFields = this.selectedFields?.filter((f) => f.selected) || [];
    const headers = ['No.', ...selectedFields.map((f) => f.label)];
    const keys = selectedFields.map((f) => f.key);

    let csvContent = headers.join(',') + '\n';

    data.forEach((item, index) => {
      const row = [
        index + 1,
        ...keys.map((key) => {
          const value = this.getDisplayValue(item[key]);
          return typeof value === 'string' && value.includes(',')
            ? `"${value}"`
            : value ?? '';
        }),
      ];
      csvContent += row.join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const fileName = 'ready-product-list.csv';

    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    link.click();

    URL.revokeObjectURL(link.href);
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  restoreColumnSelection() {
    localStorage.removeItem('stockSelected');
    this.selectedFields = [...this.defaultFields]; // Restore from the default set
    this.filterTable(); // Re-apply filter
  }

  printTable() {
    this.printTableAsync();
  }

  async printTableAsync() {
    await this.preparePdfImages();

    // Use full stockList for Print
    const data = this.getExportSourceData();

    let printContent = `
  <html>
  <head>
    <title>Ready Product(Piece) List</title>

    <style>

      body {
        font-family: Arial, sans-serif;
      }

      /* ===== TABLE GRID ===== */

      table {
        width: 100%;
        border-collapse: separate;   /* 🔥 IMPORTANT */
        border-spacing: 0;
        font-size: 11px;
      }

      th, td {
        border-right: 2px solid #000;
        border-bottom: 2px solid #000;
        padding: 6px;
        text-align: center;
        vertical-align: middle;
        white-space: nowrap;
      }

      th:first-child,
      td:first-child {
        border-left: 2px solid #000;
      }

      thead th {
        border-top: 2px solid #000;
        background-color: #f2f2f2;
        font-weight: 600;
      }

      tbody tr:last-child td {
        border-bottom: 2px solid #000;
      }

      @media print {

        @page {
          size: auto;
          margin: 8mm;
        }

        body {
          margin: 0;
        }

        thead {
          display: table-header-group;
        }

        tr {
          page-break-inside: avoid;
        }

      }

    </style>

  </head>
  <body>

    <h3>Ready Product(Piece) List</h3>

    <table>
      <thead>
        <tr>
          <th>No.</th>
  `;

    // 🧾 HEADERS
    this.selectedFieldss.forEach(field => {
      printContent += `<th>${field.label}</th>`;
    });

    printContent += `
        </tr>
      </thead>
      <tbody>
  `;

    // 📦 ROWS
    data.forEach((item, index) => {

      printContent += `
      <tr>
        <td>${index + 1}</td>
    `;

      this.selectedFieldss.forEach(field => {

        const value = item[field.key];

        let displayValue = '';

        // ✅ OBJECT FIX (Category / relations)
        if (value && typeof value === 'object') {

          displayValue =
            value.name ||
            value.category_name ||
            value.title ||
            value.label ||
            value.type ||
            '';

        } else {

          displayValue = value ?? '';

        }

        if (field.key === 'st_image1') {
          const img = item.__img ? `<img src="${item.__img}" style="width:50px;height:50px;object-fit:contain;" />` : '';
          printContent += `<td>${img}</td>`;
        } else {
          printContent += `<td>${displayValue}</td>`;
        }
      });

      printContent += `</tr>`;
    });

    printContent += `
      </tbody>
    </table>

  </body>
  </html>
  `;

    const printWindow = window.open('', '_blank');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  }


  onFieldToggle(field: any) {
    this.saveSelectedFields();
    this.filterTable();
  }

  getDisplayValue(value: any): string {
    if (value == null) return '';
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    return String(value);
  }
  private getExportSourceData(): any[] {

    const hasFilter =
      this.startDate ||
      this.endDate ||
      this.globalSearchText ||
      Object.values(this.searchValues).some(v => v);

    return hasFilter
      ? this.filteredStockList
      : this.stockList;
  }

}
